import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';


import { DiscordSDK } from "@discord/embedded-app-sdk";
import App from './App'; // Path remains the same since App.jsx is still in src/
// SoundProvider moved inside App so it can read UserContext
import reportWebVitals from './reportWebVitals';

// Parse URL params
const urlParams = new URLSearchParams(window.location.search);
const frameId = urlParams.get('frame_id');
const clientId = urlParams.get('client_id') || process.env.REACT_APP_DISCORD_CLIENT_ID;
//                                   ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
// For Vite: use import.meta.env.VITE_...
// For CRA: use process.env.REACT_APP_... (but Vite is strongly recommended now)

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

if (!frameId || !clientId) {
  // console.warn("Not running inside Discord → standalone mode");
  root.render(
    <React.StrictMode>
      <App discordSdk={null} />
    </React.StrictMode>
  );
} else {
  // console.log("Running inside Discord Activity → initializing SDK...");
  
  const sdk = new DiscordSDK(clientId);

  await sdk.ready();

//   await sdk.patchUrlMappings([
//   { prefix: "/socketio", target: process.env.REACT_APP_SOCKET_URL }
// ]);

  //const { data: { user } } = await sdk.commands.getCurrentUser();
  //console.log("Hello", user.username);

  sdk.subscribe("VOICE_STATE_UPDATES", (e) => {
    // console.log("Someone is talking:", e.user_id);
  });
      
     
  // Mount app with SDK + user
  root.render(
    <React.StrictMode>
      <App discordSdk={sdk} currentUser={"user"} />
    </React.StrictMode>
  );

}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

